import { useEffect } from 'react';

import { WS_MESSAGE_TYPE } from 'cpool-constants';

import { eventChainWsHandler } from '~/api/eventChainSocket';
import { useQueryClient } from '@tanstack/react-query';

import { wsClient } from '~/api/wsClient';
import { useUserStore } from '~/store/userStore';
import { queryKeys } from '~/utils/queryKeys';

/**
 * Opens the shared WebSocket for the authenticated session, closing on logout. Features register
 * their per-type message handlers on `wsClient` (see `wsClient.registerHandler`); this hook only owns
 * the connection lifecycle. Call once from the authenticated app shell (see routes/_app.tsx).
 */
export const useWebSocketConnection = () => {
    const user = useUserStore.use.user();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!user) return undefined;
        wsClient.registerHandler(WS_MESSAGE_TYPE.EVENT_CHAIN, eventChainWsHandler);

        wsClient.setOnForbidden(() => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAclPermissions() });
        });
        wsClient.open();

        return () => {
            wsClient.setOnForbidden(null);
            wsClient.close();
        };
    }, [queryClient, user]);
};
